import { MUISortOptions } from 'mui-datatables';
import { CompactSortDirection, CompactSortOrder, CompactSortOrders } from '../../types';

export const toStoredSortDirection = (direction: MUISortOptions['direction']): CompactSortDirection =>
  direction === 'desc' ? 'descending' : 'ascending';

export const toMuiSortDirection = (direction: CompactSortDirection): MUISortOptions['direction'] =>
  direction === 'descending' ? 'desc' : 'asc';

export const toMuiSortOrder = (stored: CompactSortOrder | undefined, sortableColumnNames: string[]): MUISortOptions | undefined => {
  if (!stored?.name || !sortableColumnNames.includes(stored.name)) {
    return undefined;
  }
  return { name: stored.name, direction: toMuiSortDirection(stored.direction) };
};

export const toStoredSortOrder = (name: string, direction: MUISortOptions['direction']): CompactSortOrder => ({
  name,
  direction: toStoredSortDirection(direction),
});

export const isSameStoredSortOrder = (a: CompactSortOrder | undefined, b: CompactSortOrder | undefined): boolean =>
  a?.name === b?.name && a?.direction === b?.direction;

export const withCompactSortOrder = (existing: CompactSortOrders | undefined, groupName: string, sortOrder: CompactSortOrder): CompactSortOrders => ({
  ...existing,
  [groupName]: sortOrder,
});
